import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { create as createFedopsLogger } from '@wix/fedops-logger';
import i18n from './i18n';
import App from './components/App';
import { ErrorDataProvider } from './hooks/use-error-data';
import { BrandStyle } from './components/constants';
import { STANDALONE_CODES } from './components/constants/custom-pages';

const locale = window.__LOCALE__;
const errorData = window.__ERROR_DATA__;
const isNotBranded = errorData.errorCode?.endsWith('-NotBranded');
const standaloneBaseCode = errorData.errorCode?.replace('-NotBranded', '');
const isStandalone =
  !!standaloneBaseCode && STANDALONE_CODES.includes(standaloneBaseCode);
const isWixel = errorData.brand === BrandStyle.wixel;
const isBase44 = errorData.brand === BrandStyle.base44;
const brandStyle = isWixel
  ? BrandStyle.wixel
  : isBase44
  ? BrandStyle.base44
  : isNotBranded
  ? BrandStyle.notBranded
  : BrandStyle.classic;

const fedopsLogger = createFedopsLogger('classic-error-pages-statics');

// Move the following `appLoaded()` call to the point where your app has fully loaded.
// See https://github.com/wix-private/fed-infra/blob/master/fedops/fedops-logger/README.md
fedopsLogger.appLoaded();

const domNode = document.getElementById('root')!;
const root = createRoot(domNode);

const supportedLanguages = [
  'en',
  'cs',
  'da',
  'de',
  'es',
  'fr',
  'id',
  'it',
  'ja',
  'ko',
  'nl',
  'no',
  'pl',
  'pt',
  'ru',
  'sv',
  'th',
  'tr',
  'uk',
  'vi',
  'zh',
];

const render = () =>
  root.render(
    <Suspense>
      <I18nextProvider i18n={i18n(locale)}>
        <ErrorDataProvider errorData={errorData}>
          <App brandStyle={brandStyle} />
        </ErrorDataProvider>
      </I18nextProvider>
    </Suspense>,
  );
const isFreeSite = window.location.origin.indexOf('wixsite.com') >= 0;
const initHeaderFooter = (brand: string) =>
  window['header-footer-provider']
    .initHeaderFooter({
      footer: false,
      languagePickerList: supportedLanguages,
      header: true,
      language: locale,
      hiddenLinks: isFreeSite ? ['language_picker', 'log_in'] : [],
      disableAuthCheck: isFreeSite,
      brand,
    })
    .then(render)
    .catch(render);
isNotBranded || isStandalone
  ? render()
  : initHeaderFooter(isWixel ? 'wixel' : isBase44 ? 'base44' : 'wix');
